<script setup>
import { computed } from "vue";
import { useRoute } from "#imports";
import { Size, BadgeColor } from "../../../interfaces/UI";
import ChargemapB2BBadge from "../global/ChargemapB2BBadge.vue";
const route = useRoute();
const emits = defineEmits(["closeMobileMenu"]);
const props = defineProps({
  link: {
    type: Object,
    required: true
  },
  isSubMenu: {
    type: Boolean,
    default: false
  },
  isSubMenuLink: {
    type: Boolean,
    default: false
  },
  isSubMenuActive: {
    type: Boolean,
    default: false
  },
  isBig: {
    type: Boolean,
    default: false
  },
  isPartner: {
    type: Boolean,
    default: true
  }
});
const isActiveRoute = computed(
  () => props.link.exact ? route?.path === props.link.url : route?.path.startsWith(props.link.url) || false
);
function closeMobileMenu() {
  emits("closeMobileMenu");
}
const fullLink = computed(() => {
  return `${props.link.url}${props.link.params || ""}`;
});
</script>

<template>
    <NuxtLink
        :id="`${link.id}`"
        :to="fullLink"
        class="rounded-md flex items-center justify-between transition-all duration-300 ease-in-out whitespace-nowrap"
        :class="[
  isBig ? 'px-3 py-2 flex-row gap-3' : 'p-3 flex-col gap-2',
  isActiveRoute ? 'bg-primary-600' : 'hover:bg-primary-600'
]"
        @click="closeMobileMenu"
    >
        <div class="flex relative gap-3 items-center overflow-hidden">
            <component
                v-if="link.icon"
                :is="link.icon"
                class="size-6 text-primary-300 icon shrink-0"
                :class="[isActiveRoute && 'text-white']"
                is-solid
            />
            <span
                v-if="isBig"
                class="text-sm text-primary-100 overflow-hidden text-ellipsis"
                :class="[
  isSubMenuLink && !link.icon && '!pl-9',
  isActiveRoute && 'text-white font-semibold'
]"
            >
                {{ link.title }}
            </span>

            <span
                v-if="link.count && !isBig"
                class="flex items-center justify-center rounded-full bg-gray-100 text-primary-500 text-xs absolute -top-3 -right-5"
                :color="isPartner ? BadgeColor.PURPLE : BadgeColor.BLUE"
                :size="Size.SM"
            >
                {{ link.count }}
            </span>
        </div>

        <ChargemapB2BBadge
            v-if="link.count && isBig"
            :color="isPartner ? BadgeColor.PURPLE : BadgeColor.BLUE"
            :size="Size.SM"
        >
            {{ link.count }}
        </ChargemapB2BBadge>

        <div v-if="isSubMenu">
            <IconChevronDown
                class="size-6 text-primary-300 transition-transform"
                :class="[isSubMenuActive && 'rotate-180 transform-gpu']"
                is-solid
            />
        </div>
    </NuxtLink>
</template>
